import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Divider.module.scss";
export const Divider = ({ orientation = "horizontal", margin = false, className, role, ...rest }) => {
    return (_jsx("div", { role: role ?? "separator", "aria-orientation": orientation, className: cn(styles.divider, orientation === "vertical" && styles.vertical, margin && styles.margin, className), ...rest }));
};
